module.exports = {"ru":{"showAllRowsButton":"Раскрыть","hideAllRowsButton":"Скрыть"},"en":{"showAllRowsButton":"Expand","hideAllRowsButton":"Hide"}}